/** Default cap on a progress-step label before it is truncated with an ellipsis. */
export const PROGRESS_LABEL_MAX_LENGTH = 48;
